import { useCallback } from 'react'
import { parseAsBoolean, parseAsString, useQueryState } from 'nuqs'
import { isValidFareClassWithReward, parseFareClassFromUrl, toBaseFareClass, type FareClassWithReward, type FlightsClassTypes } from 'constants/flight'

/**
 * Shared URL state for Maldives charter filter params. Centralises the query-state
 * reads/writes that were previously duplicated across 6+ offer-page and search-page files.
 */
export function useCharterFilterUrlState() {
  const [fareClassUrlRaw, setFareClassUrl] = useQueryState('fareClass', parseAsString)
  const [selectedCabinRaw, setSelectedCabinRaw] = useQueryState('selectedCabin', parseAsString)
  const [rewardSeatsOnly, setRewardSeatsOnly] = useQueryState('societeRewards', parseAsBoolean.withDefault(false))

  const fareClassFromUrl = fareClassUrlRaw ? parseFareClassFromUrl(fareClassUrlRaw) : undefined
  const cabinFilter: FlightsClassTypes | null = selectedCabinRaw && isValidFareClassWithReward(selectedCabinRaw)
    ? toBaseFareClass(selectedCabinRaw)
    : null

  /** Sets cabin filter URL param, normalising reward variants to base cabin. */
  const setCabinFilter = useCallback((fc: FareClassWithReward | null) => {
    setSelectedCabinRaw(fc ? toBaseFareClass(fc) : null)
  }, [setSelectedCabinRaw])

  return {
    fareClassUrlRaw,
    fareClassFromUrl,
    setFareClassUrl,
    cabinFilter,
    setCabinFilter,
    rewardSeatsOnly,
    setRewardSeatsOnly,
  }
}
